import InfoIcon from "@mui/icons-material/Info"
import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu, MenuItem } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { useAppDispatch } from "hooks"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { setCurrentOrganization } from "slices/organizationSlice"
import type { IOrganization } from "types/organizationTypes"
import { UpdateOrganizationDialog } from "./UpdateOrganizationDialog"

type Props = {
  organization: IOrganization
}

export function OrganizationListItemMenu({ organization }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const handleClickMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleClickMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  const handleClickOrganizationDetails = (_event: React.MouseEvent<HTMLElement>) => {
    dispatch(setCurrentOrganization(organization))
    navigate(organization.id)
  }

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleClickMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClickMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <MenuItem onClick={handleClickOrganizationDetails} disableRipple>
          <InfoIcon sx={{ marginRight: 1 }} />
          Details
        </MenuItem>
        <UpdateOrganizationDialog organization={organization} />
      </Menu>
    </>
  )
}
